/**
 * Default consent body (must match backend ConsentFormDefaults.java).
 */
import { CONSENT_APP_URL } from './consentFormShared';
import type { ConsentFormSection, ResolvedConsentFormConfig } from './consentFormTypes';

export function getDefaultSections(): ConsentFormSection[] {
  return [
    {
      title: '■電子交付書類',
      lines: [
        '・給与明細書',
        '・賞与明細書',
        '・給与所得の源泉徴収票',
        '・基準報酬決定通知書',
        '・基準賞与額決定通知書',
      ],
    },
    {
      title: '■記録方式',
      lines: ['PDFファイルによる交付'],
    },
    {
      title: '■閲覧方法',
      lines: ['インターネット上の指定URLへログインし閲覧', `（URL：${CONSENT_APP_URL}）`],
    },
    {
      title: '■電子交付時期',
      lines: [
        '給与および賞与の支給日',
        '給与所得の源泉徴収票、基準報酬決定通知書、基準賞与額決定通知書は交付の都度',
      ],
    },
    {
      title: '■その他（重要事項）',
      lines: [
        '・電子交付に同意した後でも、会社へ申し出ることにより書面での交付に変更することができます。',
        '・会社は、システム障害等やむを得ない事情により書面で交付する場合があります。',
        '・書面が必要な際は、各自印刷のうえご利用下さい。',
      ],
    },
  ];
}

export function getDefaultPrintNoticeLines(): string[] {
  return ['', ''];
}

/** Client-only fallback when API is unavailable. */
export function buildLocalFallbackConsentConfig(): ResolvedConsentFormConfig {
  return {
    sections: getDefaultSections(),
    printNoticeLines: getDefaultPrintNoticeLines(),
  };
}
